export interface Course {
  id?: number;
  name?: string;
  type?: string;
  duration?: string;
  isAvailable?: boolean;
}

export interface CourseState {
  course?: Course;
  availableCourses?: Course[];
}

const course: CourseState = {
  course: undefined,
  availableCourses: [],
};

export default course;
